import type { DocumentNode, DocumentSortPreference } from '../types/documents';

export const DEFAULT_DOCUMENT_SORT: DocumentSortPreference = {
  field: 'name',
  direction: 'asc',
  foldersFirst: true,
};

const storageKey = (userKey: string) => `hexa:documents:sort:${userKey || 'anonymous'}`;

export function readDocumentSortPreference(userKey: string): DocumentSortPreference {
  try {
    const value = JSON.parse(localStorage.getItem(storageKey(userKey)) || 'null');
    if (
      value && ['name', 'created_at', 'node_type'].includes(value.field)
      && ['asc', 'desc'].includes(value.direction) && typeof value.foldersFirst === 'boolean'
    ) return value;
  } catch { /* use tenant/application default */ }
  return DEFAULT_DOCUMENT_SORT;
}

export function saveDocumentSortPreference(userKey: string, value: DocumentSortPreference): void {
  localStorage.setItem(storageKey(userKey), JSON.stringify(value));
}

export function sortDocumentNodes(nodes: DocumentNode[], preference: DocumentSortPreference): DocumentNode[] {
  const multiplier = preference.direction === 'asc' ? 1 : -1;
  return [...nodes].sort((left, right) => {
    if (preference.foldersFirst && left.node_type !== right.node_type) {
      return left.node_type === 'FOLDER' ? -1 : 1;
    }
    const leftValue = preference.field === 'created_at' ? Date.parse(left.created_at) : left[preference.field];
    const rightValue = preference.field === 'created_at' ? Date.parse(right.created_at) : right[preference.field];
    if (typeof leftValue === 'number' && typeof rightValue === 'number') return (leftValue - rightValue) * multiplier;
    return String(leftValue).localeCompare(String(rightValue), 'it', { sensitivity: 'base', numeric: true }) * multiplier;
  });
}
